import type Item from 'owa-service/lib/contract/Item';
import { isEventPollRequest } from './isEventPollRequest';

export function isMeetingMessageOrEventPoll(item?: Item): boolean {
    if (!item) {
        return false;
    }
    return !!(
        item.ItemClass &&
        (item.ItemClass.match(/^ipm\.(appointment|schedule\.meeting(?!\.notification))/i) ||
            isEventPollRequest(item.ItemClass))
    );
}
